import { render, staticRenderFns } from "./NewsPaper.vue?vue&type=template&id=d5ae94a0&scoped=true"
import script from "./NewsPaper.vue?vue&type=script&lang=js"
export * from "./NewsPaper.vue?vue&type=script&lang=js"
import style0 from "./NewsPaper.vue?vue&type=style&index=0&id=d5ae94a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ae94a0",
  null
  
)

export default component.exports